import PosterFormatItem from  '../PosterFormatItem/index.jsx'
import BackgroundFormatItemContainer from '../BackgroundFormatItem/index.jsx';

const StripeItem = ({
    isChanging,
    itemData,
    theme, 
    scrollToPosition, 
    isMobile, 
    movieTimePk,
    eventOrigin,
    selectionId,
    elementDisplay,
    onOpenPerformancePage,
    stripeAppearance //is needed for overwrite
}) => {
    const { pk } = itemData

    if(theme === 'Arthouse') {
        return (
            <div className="order-wrapper slide-item">
                <BackgroundFormatItemContainer
                    movieTimePk={movieTimePk}
                    itemID={pk}
                    itemData={itemData}
                    scrollToPosition={scrollToPosition}
                    isMobile={isMobile}
                    queryStringValues={{}}
                    stripeAppearance={stripeAppearance} //is needed for overwrite
                    showPerformances={true}
                    onOpenPerformancePage={onOpenPerformancePage}
                    selectionId={selectionId}
                    elementDisplay={elementDisplay}
                />
            </div>
        )
    } else {
        return (
            <div className="slide-item">
                <PosterFormatItem
                    itemID={pk}
                    itemData={itemData}
                    showPerformances={true}
                    scrollToPosition={scrollToPosition}
                    isMobile={isMobile}
                    movieTimePk={movieTimePk}
                    isChanging={isChanging}
                    elementDisplay={elementDisplay}
                    eventOrigin={eventOrigin}
                    selectionId={selectionId}
                    onOpenPerformancePage={onOpenPerformancePage}
                />
            </div>
        )
    }
}

export default StripeItem
